import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Box,
  CircularProgress,
} from "@mui/material";
import { Calculate as CalculateIcon } from "@mui/icons-material";

interface RecalculateConfirmationDialogProps {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
  anniversaryName: string;
  loading?: boolean;
}

const RecalculateConfirmationDialog: React.FC<
  RecalculateConfirmationDialogProps
> = ({ open, onClose, onConfirm, anniversaryName, loading = false }) => {
  return (
    <Dialog
      open={open}
      onClose={!loading ? onClose : undefined}
      maxWidth="sm"
      fullWidth
      PaperProps={{
        sx: {
          borderRadius: 2,
        },
      }}
    >
      <DialogTitle>
        <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
          <CalculateIcon color="primary" />
          <Typography variant="h6" component="span">
            Recalculate Financial Settings
          </Typography>
        </Box>
      </DialogTitle>

      <DialogContent>
        <Typography variant="body1" gutterBottom>
          Are you sure you want to recalculate the financial settings for{" "}
          <strong>"{anniversaryName}"</strong>?
        </Typography>
        <Typography variant="body2" color="text.secondary">
          This action will update all related financial calculations based on
          the current anniversary settings.
        </Typography>
      </DialogContent>

      <DialogActions sx={{ px: 3, pb: 2 }}>
        <Button onClick={onClose} color="inherit" disabled={loading}>
          Cancel
        </Button>
        <Button
          onClick={onConfirm}
          variant="contained"
          color="primary"
          disabled={loading}
          startIcon={
            loading ? (
              <CircularProgress size={16} color="inherit" />
            ) : (
              <CalculateIcon />
            )
          }
        >
          {loading ? "Recalculating..." : "Recalculate"}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default RecalculateConfirmationDialog;
